import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, LoadSaveService) {

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.updateCoverages = LoadSaveService.updateSubmissionCoverages;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'qnb.LoadSaveService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/controllers/CPPAdditionalCoveragesCtrl.js
// module id = 822
// module chunks = 0